import { Alert } from 'antd';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useFeatureFlags } from '../feature-flag-react-lite';
import DOMPurify from 'dompurify';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ImpendingMessage = () => {
  const {GetFeatureFlagByName} = useFeatureFlags();
  const replaceTokens = (str: string, mapObj: any) => {
    const re = new RegExp(Object.keys(mapObj).join('|'), 'g');

    return str.replace(re, function (matched) {
      return mapObj[matched];
    });
  };

  const formatMessage = () => {
    const impendingMessage = GetFeatureFlagByName('MAINTENANCE_MSG_IMPENDING_UI_APPLICANT_PORTAL');
    const maintenanceStartTimestamp = GetFeatureFlagByName("MAINTENANCE_START_TIMESTAMP_UI_APPLICANT_PORTAL");
    const maintenanceEndTimestamp = GetFeatureFlagByName("MAINTENANCE_END_TIMESTAMP_UI_APPLICANT_PORTAL");

    const startTimestampStr = dayjs(maintenanceStartTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const endTimestampStr = dayjs(maintenanceEndTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const startDateStr = dayjs(maintenanceStartTimestamp).tz('America/New_York').format('MMMM DD');
    const endDateStr = dayjs(maintenanceEndTimestamp).tz('America/New_York').format('MMMM DD');
    const timeRangeStr = startDateStr === endDateStr ? startDateStr : `${startDateStr} - ${endDateStr}`;
    const mapObj = {
      '##startTimestampStr##': startTimestampStr,
      '##endTimestampStr##': endTimestampStr,
      '##timeRangeStr##': timeRangeStr
    };
    return replaceTokens(impendingMessage, mapObj);
  };

  return (
    <div style={{ textAlign: 'center' }} data-testid="impending-message">
      <Alert message={<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatMessage()) }}></div>} />
    </div>
  );
};
